<template>
  <div class="page-head">
    <h1>{{ t("À propos", "About") }}</h1>
  </div>

  <section class="sec intro">
    <div class="about-grid">
      <div class="portrait"><img :src="avatar" :alt="t('Portrait d\'Arolle Fona', 'Portrait of Arolle Fona')" /></div>
      <div v-if="lang === 'fr'">
        <p class="lead">Je suis <b>Arolle Fona</b>, développeuse <b>fullstack JavaScript</b> à Douala.</p>
        <p>
          Je conçois des applications web et mobiles de bout en bout, de l'API à l'interface. J'ai surtout travaillé sur des produits
          de paiement et de transfert d'argent.
        </p>
        <p>
          En 2025, j'ai co-fondé <a class="mark" href="https://www.devgirls.org" target="_blank" rel="noopener">Dev Girls</a> avec
          Linda Mballa, une communauté qui aide les femmes passionnées par la tech. On y organise des meetups, des ateliers et des
          tables rondes.
        </p>
        <p>
          En dehors du code, je suis <b>passionnée de lecture et d'écriture</b>. J'écris des articles techniques, et aussi des textes
          plus personnels.
        </p>
      </div>
      <div v-else>
        <p class="lead">I'm <b>Arolle Fona</b>, a <b>fullstack JavaScript</b> developer in Douala.</p>
        <p>
          I build web and mobile applications end to end, from the API to the interface. Most of my work has been on payment and money
          transfer products.
        </p>
        <p>
          In 2025, I co-founded <a class="mark" href="https://www.devgirls.org" target="_blank" rel="noopener">Dev Girls</a> with Linda
          Mballa, a community that supports women passionate about tech. We run meetups, workshops and panels.
        </p>
        <p>
          Outside of code, I'm <b>passionate about reading and writing</b>. I write technical articles, and more personal texts too.
        </p>
      </div>
    </div>
  </section>

  <section class="sec">
    <div class="sec-head">
      <h2><Code />{{ t("Ma stack", "My stack") }}</h2>
    </div>
    <div class="stack">
      <span v-for="s in stack" :key="s.name"><img class="mono" :src="s.img" alt="" width="18" height="18" loading="lazy" />{{ s.name }}</span>
    </div>
  </section>

  <section class="sec">
    <div class="grid-2 even">
      <div>
        <div class="sec-head">
          <h2><BookOpen />{{ t("Ce que je lis en ce moment", "What I'm reading") }}</h2>
        </div>
        <div class="book">
          <img :src="books.cover" :alt="t('Couverture de Sapiens', 'Sapiens book cover')" width="96" height="144" />
          <div>
            <div class="k">{{ t("En cours de lecture", "Currently reading") }}</div>
            <h3>{{ t("Sapiens : une brève histoire de l'humanité", "Sapiens: A Brief History of Humankind") }}</h3>
            <p class="muted">Yuval Noah Harari</p>
            <p class="summary">
              {{
                t(
                  "Comment une espèce parmi d'autres a fini par raconter des histoires assez fortes pour bâtir des empires, des religions et de l'argent.",
                  "How one species among many ended up telling stories strong enough to build empires, religions and money."
                )
              }}
            </p>
          </div>
        </div>
        <a class="btn books" :href="books.drive" target="_blank" rel="noopener">
          {{ t("Voir ma suggestion de livres", "See my book suggestions") }} <ArrowUpRight />
        </a>
      </div>
      <div>
        <div class="sec-head">
          <h2><Heart />{{ t("Un de mes textes", "One of my texts") }}</h2>
          <span v-if="lang === 'en'" class="muted">In French</span>
        </div>
        <blockquote class="poem" lang="fr">
          <p v-for="(line, i) in poem" :key="i">{{ line }}</p>
          <footer>— Arolle Fona</footer>
        </blockquote>
      </div>
    </div>
  </section>

  <section id="ecrits" class="sec">
    <div class="sec-head">
      <h2><PenLine />{{ t("J'écris aussi sur la tech", "I also write about tech") }}</h2>
      <a class="link" href="https://medium.com/@arollefona11" target="_blank" rel="noopener">{{ t("Sur Medium", "On Medium") }} <ArrowUpRight /></a>
    </div>
    <ArticleList :items="articles" />
  </section>
</template>

<script>
import { ArrowUpRight, BookOpen, Code, Heart, PenLine } from "lucide-vue-next";
import ArticleList from "@/components/ArticleList.vue";
import { ARTICLES, AVATAR, BOOKS, POEM, STACK } from "@/content";
import { useI18n } from "@/i18n";

export default {
  name: "AboutPage",
  components: { ArrowUpRight, BookOpen, Code, Heart, PenLine, ArticleList },
  setup() {
    return { ...useI18n(), avatar: AVATAR, stack: STACK, books: BOOKS, poem: POEM, articles: ARTICLES };
  },
};
</script>

<style scoped>
.intro {
  padding-top: 32px;
}
.lead {
  margin-top: 0;
}
.summary {
  font-size: 15px;
  margin-top: 8px;
}
.books {
  margin-top: 24px;
  display: inline-flex;
}
</style>
